import { Button } from '@/app/common/components/Button'
import { Card, CardContent } from '@/app/common/components/Card'
import { Provider } from '@/schemas/provider.schema'
import { useTranslation } from 'react-i18next'
import FamilyWizardLayout from '../../family_application/FamilyWizardLayout'

type Props = {
  provider: Provider
  onBack: () => void
  onNext: () => void
}

export const ConfirmProvider = (props: Props) => {
  const { provider, onBack, onNext} = props
  const { t: translate } = useTranslation()

  const onChange = () => {
    onBack()
  }


  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        <h1>{translate('who_do_you_want_to_pay')}</h1>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className="w-full">
        <div className="flex w-full text-lg justify-center font-medium text-gray-500 mb-3">
        {translate('selected_vendor')}
        </div>
        <Card>
          <CardContent className="">
            <div className="py-3 flex justify-between items-center">
              <div>
                <h4 className="font-medium text-gray-800">
                  {provider.name}
                </h4>
                <address className="not-italic text-gray-700">
                  {provider.location}
                </address>
              </div>
              <div className="flex text-md font-bold">
                <Button variant="outline" onClick={onChange} className="px-5">
                  {translate('change_provider')}
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
        <div className="flex justify-center mt-10 gap-2">
          <div className="flex justify-start">
            <Button variant="outline" onClick={onChange} className="px-10">
              {translate('back')}
            </Button>
          </div>
          <div className="flex justify-end">
            <Button onClick={onNext} className="px-10">
              {translate('next')}
            </Button>
          </div>
        </div>
      </FamilyWizardLayout.Content>
    </FamilyWizardLayout>
  )
}
